<template>
  <div class="upload-test-result">
    <el-form 
      ref="uploadForm" 
      :model="form" 
      :rules="rules" 
      label-width="120px"
      class="upload-form">
      
      <!-- 订单基本信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>订单基本信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="form.projectName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单编号" prop="orderNo">
              <el-input v-model="form.orderNo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家名称" prop="merchantName">
              <el-input v-model="form.merchantName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="form.customerName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="仪器信息" prop="deviceInfo">
              <el-input v-model="form.deviceInfo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="样品数量" prop="sampleCount">
              <el-input v-model="form.sampleCount" disabled>
                <template slot="append">个</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间" prop="createTime">
              <el-input v-model="form.createTime" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试要求附件" prop="requirementFiles">
              <div v-if="form.requirementFiles && form.requirementFiles.length > 0" class="file-list-container">
                <el-table
                  :data="form.requirementFiles"
                  style="width: 100%"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                    <template slot-scope="scope">
                      {{ scope.row.name || '未命名文件' }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="150"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else class="no-file">
                <el-empty description="暂无附件"></el-empty>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 测试结果信息 - 仅在复测时显示 -->
      <el-card v-if="isRetest" class="form-card">
        <div slot="header">
          <span>测试结果信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试说明" prop="originalTestDescription">
              <el-input 
                type="textarea" 
                v-model="form.originalTestDescription"
                :rows="4"
                disabled>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试报告" prop="testResultFiles">
              <div v-if="form.testResultFiles && form.testResultFiles.length > 0" class="file-list-container">
                <el-table
                  :data="form.testResultFiles"
                  style="width: 100%"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                    <template slot-scope="scope">
                      {{ scope.row.name || '未命名文件' }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="150"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else class="no-file">
                <el-empty description="暂无附件"></el-empty>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 申请复测信息 - 仅在复测时显示 -->
      <el-card v-if="isRetest" class="form-card">
        <div slot="header">
          <span>申请复测信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="申请复测说明" prop="retestApplyRemark">
              <el-input 
                type="textarea" 
                v-model="form.retestApplyRemark"
                :rows="4"
                disabled>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="申请复测附件" prop="retestApplyFiles">
              <div v-if="form.retestApplyFiles && form.retestApplyFiles.length > 0" class="file-list-container">
                <el-table
                  :data="form.retestApplyFiles"
                  style="width: 100%"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                    <template slot-scope="scope">
                      {{ scope.row.name || '未命名文件' }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="150"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else class="no-file">
                <el-empty description="暂无附件"></el-empty>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 测试结果信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>{{ isRetest ? '复测结果信息' : '测试结果信息' }}</span>
        </div>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="isRetest ? '复测说明' : '测试说明'" prop="testDescription">
              <el-input 
                type="textarea" 
                v-model="form.testDescription"
                :rows="4"
                :placeholder="isRetest ? '请输入复测说明' : '请输入测试说明'">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="isRetest ? '复测报告' : '测试报告'" prop="fileList">
              <el-upload
                class="upload-demo"
                action="#"
                :http-request="handleFileUpload"
                :file-list="[]"
                :on-remove="handleRemove"
                :before-upload="beforeUpload"
                drag
                multiple
                :limit="5"
                :show-file-list="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">
                  上传{{ isRetest ? '复测' : '测试' }}报告、{{ isRetest ? '复测' : '测试' }}图片等结果文件，支持PDF、Word、Excel、图片或压缩包(ZIP/RAR/7Z)等格式
                  <span style="color: #F56C6C; margin-left: 10px;">文件名必须包含订单号 {{ form.orderNo }}</span>
                </div>
              </el-upload>
              
              <!-- 使用表格显示已上传文件 -->
              <div v-if="form.fileList && form.fileList.length > 0" class="uploaded-files">
                <h3 class="file-list-title">已上传文件</h3>
                <el-table
                  :data="form.fileList"
                  style="width: 100%; margin-top: 15px;"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="180"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                      <el-button 
                        type="text" 
                        size="small"
                        style="color: #F56C6C; margin-left: 10px;"
                        @click="handleRemoveUploaded(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 操作按钮 -->
      <div class="form-actions">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">{{ isRetest ? '提交复测结果' : '提交测试结果' }}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'UploadTestResult',
  props: {
    orderId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      form: {
        orderNo: '',
        createTime: '',
        deviceType: '',
        deviceCount: '',
        testDescription: '',
        fileList: [],
        projectName: '',
        merchantName: '',
        customerName: '',
        deviceInfo: '',
        sampleCount: '',
        requirementFiles: [],
        originalTestDescription: '',
        testResultFiles: [],
        retestApplyRemark: '',
        retestApplyFiles: []
      },
      rules: {
        testDescription: [
          { required: true, message: '请输入测试说明', trigger: 'blur' }
        ],
        fileList: [
          { required: false, message: '请上传测试报告', trigger: 'change' }
        ]
      },
      uploadingFiles: 0,
      isRetest: false
    }
  },
  created() {
    this.isRetest = this.$route.query.action === 'upload_retest'
    if (this.orderId) {
      this.getOrderDetail()
    } else {
      console.error('缺少订单ID')
      this.$message.error('缺少订单ID，无法获取订单详情')
    }
  },
  methods: {
    async getOrderDetail() {
      try {
        const res = await adminApi.getOrderById(this.orderId)
        console.log('获取到的订单详情:', res)
        if (res) {
          const orderData = res
          // 打印关键属性，方便调试
          console.log('订单编号:', orderData.orderSn)
          console.log('仪器名称:', orderData.deviceName)
          console.log('样品数量:', orderData.testCount)
          console.log('附件列表:', orderData.orderFile)
          
          this.form = {
            ...this.form,
            orderNo: orderData.orderSn || '',
            createTime: orderData.createTime || '',
            deviceType: orderData.deviceType || '',
            deviceCount: orderData.testCount || '',
            projectName: orderData.projectName || '',
            merchantName: orderData.merchantName || '',
            customerName: orderData.customerName || '',
            deviceInfo: orderData.deviceName || '',
            sampleCount: orderData.testCount || '',
            requirementFiles: Array.isArray(orderData.orderFile) ? orderData.orderFile.map(file => ({
              name: file.fileName || '未命名文件',
              size: file.fileSize || 0,
              url: file.fileUrl || file.url || '',
              fileId: file.fileId || file.id
            })) : [],
            originalTestDescription: orderData.testResultRemark || '',
            testResultFiles: Array.isArray(orderData.orderResultFile) ? orderData.orderResultFile.map(file => ({
              name: file.fileName || '未命名文件',
              size: file.fileSize || 0,
              url: file.fileUrl || file.url || '',
              fileId: file.fileId || file.id
            })) : [],
            testReportFileList: Array.isArray(orderData.orderTestReportFileList) ? orderData.orderTestReportFileList.map(file => ({
              name: file.fileName || '未命名文件',
              size: file.fileSize || 0,
              url: file.fileUrl || file.url || '',
              fileId: file.fileId || file.id
            })) : [],
            testCheckFileList: Array.isArray(orderData.orderTestCheckFileList) ? orderData.orderTestCheckFileList.map(file => ({
              name: file.fileName || '未命名文件',
              size: file.fileSize || 0,
              url: file.fileUrl || file.url || '',
              fileId: file.fileId || file.id
            })) : []
          }
          
          // 如果是复测，添加申请复测信息
          if (this.isRetest) {
            // 从 orderRetestList 中获取申请复测说明和申请复测附件
            const retestList = Array.isArray(orderData.orderRetestList) ? orderData.orderRetestList : []
            if (retestList.length > 0) {
              const latestRetest = retestList[retestList.length - 1]
              this.form.retestApplyRemark = latestRetest.disputeRemark || ''
              this.form.retestApplyFiles = Array.isArray(latestRetest.orderDisputeFile) ? latestRetest.orderDisputeFile.map(file => ({
                name: file.fileName || '未命名文件',
                size: file.fileSize || 0,
                url: file.fileUrl || file.url || '',
                fileId: file.fileId || file.id
              })) : []
            } else {
              this.form.retestApplyRemark = ''
              this.form.retestApplyFiles = []
            }
          }
          
          console.log('处理后的表单数据:', this.form)
        } else {
          this.$message.error('获取订单详情失败')
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败: ' + (error.message || '未知错误'))
        
        // 确保即使API调用失败，相关字段也有一个空数组
        this.form.requirementFiles = []
        this.form.testResultFiles = []
        this.form.retestApplyFiles = []
        this.form.testReportFileList = []
        this.form.testCheckFileList = []
      }
    },
    handleCancel() {
      this.$router.back()
    },
    handleSubmit() {
      this.$refs.uploadForm.validate(async valid => {
        if (valid) {
          if (this.uploadingFiles > 0) {
            this.$message.warning(`还有 ${this.uploadingFiles} 个文件正在上传，请等待上传完成后再提交`)
            return
          }

          try {
            const params = {
              id: this.orderId,
              orderStatus: this.isRetest ? 'RETESTING' : 'TESTING',
              testResultRemark: this.form.testDescription,
              orderResultFile: this.form.fileList.map(file => ({
                fileId: file.name,
                filePath: file.path,
                fileName: file.fileId,
                fileUrl: file.url,
                fileSize: file.size
              }))
            }
            
            if (this.isRetest) {
              params.testResultRemark = this.form.testDescription
              params.orderRetestResultFileList = params.orderResultFile
              delete params.orderResultFile
            }
            
            const res = await adminApi.editOrder(params)
            if (res) {
              this.$message.success(this.isRetest ? '复测结果提交成功' : '测试结果提交成功')
              
              // 根据用户角色决定跳转路径
              const userRole = localStorage.getItem('userRole')
              if (userRole === 'merchant') {
                // 商家端跳转到商家的订单页面
                this.$router.push(this.isRetest ? '/merchant/orders/dispute' : '/merchant/orders/tested')
              } else {
                // 管理员端跳转到管理员的订单页面
                this.$router.push(this.isRetest ? '/admin/orders/dispute' : '/admin/orders/tested')
              }
            } else {
              this.$message.error(this.isRetest ? '复测结果提交失败' : '测试结果提交失败')
            }
          } catch (error) {
            console.error('提交结果失败:', error)
            this.$message.error('提交结果失败: ' + (error.message || '未知错误'))
          }
        }
      })
    },
    async handleFileUpload(options) {
      const { file } = options
      
      if (this.form.orderNo && !file.name.includes(this.form.orderNo)) {
        this.$message.error(`文件名 ${file.name} 不包含订单号 ${this.form.orderNo}，请重命名后上传`)
        return
      }
      
      this.uploadingFiles++
      
      try {
        const res = await adminApi.uploadFile(file, '', (percent) => {
          console.log(`上传进度: ${parseInt(percent)}%`)
        })
        
        if (res) {
          const fileData = res
          const newFile = {
            name: fileData.fileId,
            size: file.size,
            uploadTime: new Date(),
            url: fileData.url || fileData.fileUrl,
            fileId: fileData.fileId || fileData.id,
            path: fileData.path || '',
            status: 'success'
          }
          
          this.form.fileList.push(newFile)
          this.$message.success(`文件 ${file.name} 上传成功`)
        } else {
          this.$message.error(`文件 ${file.name} 上传失败，请重试`)
        }
      } catch (error) {
        console.error('文件上传失败:', error)
        this.$message.error(`文件 ${file.name} 上传失败: ${error.message || '未知错误'}`)
      } finally {
        this.uploadingFiles--
      }
    },
    handleRemove(file) {
      const index = this.form.fileList.findIndex(item => 
        (item.uid === file.uid) || (item.name === file.name && item.size === file.size)
      )
      
      if (index !== -1) {
        this.form.fileList.splice(index, 1)
      }
    },
    beforeUpload(file) {
      // 检查文件大小
      const isLt200M = file.size / 1024 / 1024 < 200
      if (!isLt200M) {
        this.$message.error('文件大小不能超过200MB!')
        return false
      }
      
      // 检查文件类型
      const allowedTypes = [
        'application/pdf', 
        'application/msword', 
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/jpeg',
        'image/png',
        'image/gif',
        'application/zip',
        'application/x-zip-compressed',
        'application/x-rar-compressed',
        'application/octet-stream',
        'application/x-7z-compressed'
      ]
      
      // 获取文件扩展名
      const fileName = file.name
      const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()
      const allowedExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png', 'gif', 'zip', 'rar', '7z']
      
      // 同时检查MIME类型和文件扩展名
      const isAllowedType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension)
      
      if (!isAllowedType) {
        this.$message.warning('请上传PDF、Word、Excel、图片或压缩包(ZIP/RAR/7Z)格式的文件')
        console.log('文件类型不允许:', file.type, fileExtension)
        return false
      }
      
      return true
    },
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    formatFileSize(size) {
      if (size < 1024) {
        return size + ' B'
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB'
      } else if (size < 1024 * 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(2) + ' MB'
      } else {
        return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB'
      }
    },
    handleRemoveUploaded(index) {
      // 从已上传文件列表中移除文件
      this.form.fileList.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.upload-test-result {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.upload-form {
  width: 100%;
}

.form-card {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.el-form-item {
  margin-bottom: 22px;
  width: 100%;
}

.el-input,
.el-select,
.el-date-picker,
.el-radio-group,
.el-upload {
  width: 100%;
}

/* 单选框组靠左对齐 */
.radio-group-left {
  text-align: left;
  display: flex;
  justify-content: flex-start;
}

/* 确保文本域字体样式与其他输入框一致 */
.el-textarea__inner {
  font-family: inherit !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  color: #606266 !important;
}

/* 修复单选框与标签文字对齐问题 */
.el-radio {
  line-height: 32px;
  margin-right: 30px;
}

.el-radio__input {
  vertical-align: middle;
}

.el-radio__label {
  vertical-align: middle;
}

/* 修复处理结果标签与单选框组的对齐问题 */
.el-form-item.is-required .el-form-item__label:before {
  vertical-align: middle;
}

.el-form-item__label {
  line-height: 32px !important;
}

.el-form-item__content {
  line-height: 32px !important;
}

.form-actions {
  margin-top: 30px;
  text-align: center;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 10px;
}

.upload-demo {
  width: 100%;
}

.el-upload {
  width: 100%;
}

.el-upload-dragger {
  width: 100%;
}

.el-upload__tip {
  line-height: 1.5;
  margin-top: 10px;
  color: #909399;
}

.file-list {
  display: flex;
  flex-wrap: wrap;
}

.file-item {
  display: flex;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 10px;
}

.file-item .el-icon-document {
  margin-right: 5px;
}

.file-item .file-name {
  margin-right: 5px;
}

.file-list-container {
  margin-bottom: 20px;
}

.file-list-title {
  margin-bottom: 10px;
  font-weight: bold;
}

.no-file {
  text-align: center;
  padding: 20px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
}

.uploaded-files {
  margin-top: 20px;
}

.uploaded-files .file-list-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #606266;
}

.uploaded-files .el-table {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
</style>

<!-- 添加全局样式 -->
<style>
.upload-test-result .el-textarea__inner {
  font-family: inherit !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  color: #606266 !important;
}

.upload-test-result .el-form-item__label,
.upload-test-result .el-form-item__content {
  line-height: 32px !important;
}
</style> 